export class AppError extends Error {
  readonly code: string;
  override readonly cause?: unknown;

  constructor(message: string, code: string, cause?: unknown) {
    super(message);
    this.name = "AppError";
    this.code = code;
    this.cause = cause;
  }
}

export type SupabaseError = {
  code?: string;
  message: string;
};

const messages: Record<string, string> = {
  "23503": "This item still has related content.",
  "23505": "That value is already in use.",
  "23514": "Some of the supplied data is invalid.",
  "42501": "You do not have permission to perform this action.",
  PGRST116: "The requested item was not found.",
};

// Per-user quota triggers (sites, assets) raise this SQLSTATE with a message
// written for users, so it is shown as-is.
const QUOTA_EXCEEDED = "HZQ01";

export const toAppError = (error: SupabaseError, fallback: string) =>
  new AppError(
    (error.code === QUOTA_EXCEEDED ? error.message : messages[error.code ?? ""]) ??
      fallback,
    error.code ?? "SUPABASE_ERROR",
    error,
  );

export const requireData = <T>(
  data: T | null,
  error: SupabaseError | null,
  fallback: string,
): T => {
  if (error) throw toAppError(error, fallback);
  if (data === null) throw new AppError(fallback, "NO_DATA");
  return data;
};

export const requireSuccess = (
  error: SupabaseError | null,
  fallback: string,
) => {
  if (error) throw toAppError(error, fallback);
};
